import { ReactNode } from 'react';
import { LocalizedLabel } from '@mews-commander/ui';
import { Grid, GridItem } from '@optimus-web/core';

export interface PaymentDetailsLocalizedEntry {
    value: ReactNode;
    textKey: Mews.TextKey;
}

export interface PaymentDetailsCustomEntry {
    value: string | null;
    customLabel: string;
}

export const PaymentDetailsEntry = (props: PaymentDetailsLocalizedEntry | PaymentDetailsCustomEntry) => (
    <Grid templateColumns="2fr 3fr">
        <GridItem>
            {'textKey' in props ? <LocalizedLabel textKey={props.textKey} as="div" /> : props.customLabel}
        </GridItem>
        {props.value && <GridItem>{props.value}</GridItem>}
    </Grid>
);
